// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/app/pagecontainer/components/chatinterface/components/insight/index.scss
// module id = 2545
// module chunks = 13